<template>
  <section class="pathways-section" v-if="!isLoading">
    <div class="row outcomes-row">
      <header v-if="outcome" class="col-md-12 outcome-title">
        <div class="outcome-title-text">
          <div
            class="outcome-title-header"
            v-html="cms.asHtml(outcome.full_title)"
            data-test="personal-outcome-title"
          ></div>
          <p
            class="outcome-title-desc"
            v-html="cms.asHtml(outcome.brief_description)"
            data-test="personal-outcome-desc"
          ></p>
        </div>
        <div class="outcome-image-container">
          <img
            :src="outcome.image.url"
            :alt="cms.asText(outcome.name)"
            class="outcome-image"
            data-test="personal-outcome-img"
          />
        </div>
      </header>
      <router-view
        :relatedPathways="relatedPathways"
        :outcome="outcome"
        @display-next-button="toggleDisplayNextButton"
        @hide-stepper="hideStepper"
      />
      <div class="col-md-12 text-center next-button-container">
        <router-link v-if="pathwayUid && isNextButtonDisplayed" :to="`pathway/${pathwayUid}`">
          <button class="btn btn-primary" data-test="personal-pathway-next" type="button">
            Next
          </button>
        </router-link>
      </div>
    </div>
  </section>
  <LoadingPage v-else />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import LoadingPage from "../../views/loading-page.vue";
import {
  CmsDocumentTypes,
  CmsGoalData,
  CmsPathwaysRelationship,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";

const emit = defineEmits(["update-stepper", "hide-stepper"]);

const route = useRoute();

const isLoading = ref(true);

const outcomeUid = ref<string>("");

const outcome = ref<CmsGoalData | null>(null);

const pathwayUid = ref<string>("");

const isNextButtonDisplayed = ref(false);

const routeName = ref<string>(route.name as string);

const toggleDisplayNextButton = (selectedPathwayUid: string): void => {
  isNextButtonDisplayed.value = !isNextButtonDisplayed.value;
  pathwayUid.value = selectedPathwayUid;
};

const relatedPathways = computed<CmsPathwaysRelationship[]>(() => {
  return outcome.value?.pathways ?? [];
});

const hideStepper = (): void => {
  emit("hide-stepper");
};

onMounted(async () => {
  outcomeUid.value = route.params.outcomeUid as string;
  const response = await cms.getByUid(CmsDocumentTypes.CmsPersonalGoal, outcomeUid.value);
  outcome.value = response.data;
  emit("update-stepper", routeName.value);
  isLoading.value = false;
});
</script>

<style scoped lang="less">
@import "../../styles/outcomes/pathways";
</style>
<style lang="less">
@import "../../styles/outcomes/pathways-prismic-content";
</style>
